import React from 'react';
import { useModalContext } from '../ModalContext';
import { ModalTriggerProps } from '../types';

const ModalTrigger = ({ children, as: Element = 'span', dataTestId, isDisabled = false }: ModalTriggerProps) => {
  const { open } = useModalContext();

  return (
    <Element onClick={isDisabled ? undefined : open} data-testid={dataTestId}>
      {children}
    </Element>
  );
};

ModalTrigger.displayName = 'ModalTrigger';

export default ModalTrigger;
